import { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

const HERO_BG = "/assets/hero_bg.png";

export default function Hero() {
    const { t } = useLanguage();
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToQuote = () => {
        document.getElementById("presupuesto")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section className="relative min-h-[85vh] flex items-center overflow-hidden" data-testid="hero-section">
            <div className="absolute inset-0">
                <img
                    src={HERO_BG}
                    alt=""
                    className="w-full h-full object-cover will-change-transform"
                    loading="eager"
                    style={{ transform: `translateY(${scrollY * 0.3}px) scale(1.1)` }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/90 via-[#0A1628]/70 to-[#0A1628]/40" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 md:py-32">
                <div className="max-w-2xl">
                    <h1
                        className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight animate-fade-in-up"
                        data-testid="hero-title"
                    >
                        {t.hero.title}
                    </h1>
                    <p className="mt-6 text-lg md:text-xl text-slate-300 leading-relaxed animate-fade-in-up" style={{ animationDelay: "150ms" }}>
                        {t.hero.subtitle}
                    </p>
                    <div className="mt-8 space-y-3">
                        {[t.hero.check1, t.hero.check2, t.hero.check3].map((check, i) => (
                            <div
                                key={i}
                                className="flex items-center gap-3 text-white animate-fade-in-up"
                                style={{ animationDelay: `${300 + i * 100}ms` }}
                            >
                                <CheckCircle className="w-5 h-5 text-blue-400 flex-shrink-0" />
                                <span className="text-base">{check}</span>
                            </div>
                        ))}
                    </div>
                    <div className="mt-10 animate-fade-in-up" style={{ animationDelay: "600ms" }}>
                        <Button
                            onClick={scrollToQuote}
                            className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 py-6 text-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-blue-600/25 hover:-translate-y-0.5"
                            data-testid="hero-cta"
                        >
                            {t.hero.cta}
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
}
